import { Button, Table } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from '../../components/EmptyState';
import { StatusBadge } from '../../components/StatusBadge';
import { ApiError } from '../../lib/http';
import { MISSING_REASON } from '../../lib/status';
import { reservationsApi } from '../../services/resources';
import type { Reservation } from '../../types/api';

export function TeacherSchedulePage() {
  const nav = useNavigate();
  const [items, setItems] = useState<Reservation[]>([]);
  const [error, setError] = useState('');

  async function load() {
    try {
      const p = await reservationsApi.list({ page: 1, limit: 50 });
      setItems(p.items);
      setError('');
    } catch (e) {
      setError(e instanceof ApiError ? `列表加载失败：${e.message}` : '列表加载失败，请检查网络后重试');
    }
  }

  useEffect(() => {
    void load();
  }, []);

  return (
    <div className="stack">
      <h1 className="page-title">我的课表</h1>
      <Button type="primary" className="touch" onClick={() => nav('/teacher/reservations/new')}>
        预约实验室
      </Button>
      {error ? (
        <EmptyState text={error} action={{ label: '重新加载', onClick: () => void load() }} />
      ) : items.length === 0 ? (
        <EmptyState text="本周还没有预约。需要实验室时点预约实验室。" kind="search" />
      ) : (
        <Table
          scroll={{ x: 720 }}
          rowKey="id"
          dataSource={items}
          pagination={false}
          columns={[
            {
              title: '实验室',
              render: (_, r) => <span className="mono">{r.lab?.room_code ?? r.lab_id}</span>,
            },
            {
              title: '日期节次',
              render: (_, r) => `${r.date} ${(r.period_names ?? []).join('、')}`,
            },
            {
              title: '状态',
              render: (_, r) => <StatusBadge status={r.status} reasonType={r.reason_type} />,
            },
            {
              title: '原因',
              render: (_, r) =>
                r.status === 'rejected' ? r.reject_reason || r.comment || MISSING_REASON : r.remark,
            },
          ]}
        />
      )}
    </div>
  );
}
